










export default {
  props: {
    disabled: Boolean,
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    add() {
      if (!this.value || this.disabled) {
        return;
      }

      // add new blank column
      const payload = this.value.map((row: string[]) => row.concat(''));
      this.$emit('input', payload);
    },
  },
} as IView;
